Monitoring.Views ||= {}

class Monitoring.Views.MovistarRuleListView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_rule_list"]

  events:
    'change .active-checkbox': 'onChangeActive'
    'click .delete-rule': 'onClickDelete'

  initialize: (@options = {}) ->
    @rules             = @options.rules
    @availableTags     = @options.availableTags
    @availableSubtypes = @options.availableSubtypes
    @currentUser       = @options.currentUser
    @accountId         = @options.accountId

  render: =>
    @$el.html(@template(@))
    @initializeToggle()
    @

  initializeToggle: ->
    @$el.find('.active-checkbox').bootstrapToggle({
      onstyle: 'success'
      offstyle: 'warning'
    })

  onChangeActive: (evt) ->
    ruleId = $(evt.currentTarget).data('id')
    ruleToEdit = @rules.get(ruleId)
    if evt.currentTarget.checked
      @updateActiveStatus(ruleToEdit, true)
      @trigger('rule:activated')
    else
      @updateActiveStatus(ruleToEdit, false)
      @trigger('rule:deactivated')

  updateActiveStatus: (rule, newActiveStatus) ->
    rule.set('active', newActiveStatus)
    rule.set('updated_at', new Date().toISOString())
    rule.set('updated_by', @currentUser.full_name)
    @$el.find('.updated-at-cell[data-id="' + rule.id.toString() + '"]').html(rule.getFormattedUpdatedAt())
    @$el.find('.updated-by-cell[data-id="' + rule.id.toString() + '"]').html(rule.get('updated_by'))
    rule.save({}, {
      success: (response) =>
        console.log("Updated active status of rule:")
        console.log(response)
      error: (response) =>
        console.log("Error saving rule:")
        console.log(response)
    })

  onClickDelete: (evt) ->
    swal({
      title: I18n.t('monitoring.rules.confirmation.are_you_sure')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.rules.confirmation.confirm')
      cancelButtonText: I18n.t('monitoring.rules.confirmation.cancel')
      closeOnConfirm: true
    }, =>
      ruleId = $(evt.currentTarget).data('id')
      ruleToDelete = @rules.get(ruleId)
      ruleToDelete.destroy(
        success: (response) =>
          @trigger('rule:deactivated') if ruleToDelete.get('active')
          console.log("Deleted rule #{ruleToDelete.get('name')}")
          @rules.remove(ruleToDelete)
          @render()
        error: (response) =>
          console.log("Error deleting rule #{ruleToDelete.get('name')}")
      )
    )

  getConditionsAsText: (rule) ->
    _.filter([
      @getParentPostIdsString(rule),
      @getParentMediaIdsString(rule),
      @getParentTweetIdsString(rule),
      @getTagsString(rule),
      @getSubtypesString(rule),
      @getOwnershipString(rule),
    ], (str) -> str != "").join('<br>')

  getParentPostIdsString: (rule) ->
    if rule.get('social_content_condition').parent_post_ids.length > 0
      "#{I18n.t('monitoring.rules.fields.parent_post_ids')}: #{rule.get('social_content_condition').parent_post_ids.join(', ')}"
    else
      ""

  getParentMediaIdsString: (rule) ->
    if rule.get('social_content_condition').parent_media_ids.length > 0
      "#{I18n.t('monitoring.rules.fields.parent_media_ids')}: #{rule.get('social_content_condition').parent_media_ids.join(', ')}"
    else
      ""

  getParentTweetIdsString: (rule) ->
    if rule.get('social_content_condition').parent_tweet_ids.length > 0
      "#{I18n.t('monitoring.rules.fields.parent_tweet_ids')}: #{rule.get('social_content_condition').parent_tweet_ids.join(', ')}"
    else
      ""

  getTagsString: (rule) ->
    if rule.get('social_content_condition').tags.length > 0
      tagDescriptions = _.map(rule.get('social_content_condition').tags, (clientCode) =>
        matchingTag = _.find(@availableTags, (tag) -> tag.code == clientCode)
        (matchingTag || {description: clientCode}).description
      )
      "#{I18n.t('monitoring.rules.fields.tags')}: #{tagDescriptions.join(', ')}"
    else
      ""

  getSubtypesString: (rule) ->
    if rule.get('social_content_condition').subtypes.length > 0
      subtypeNames = _.map(rule.get('social_content_condition').subtypes, (code) =>
        _.find(@availableSubtypes, (subtype) -> subtype.code == code).name
      )
      "#{I18n.t('monitoring.rules.fields.types')}: #{subtypeNames.join(', ')}"
    else
      ""

  getOwnershipString: (rule) ->
    if rule.get('social_content_condition').ownership == 'not-own-content'
      "Excluir contenido propio"
    else
      ""

  getActionsAsText: (rule) ->
    action = rule.get('actions')[0]
    if action
      _.filter([
        @getRemoveAllTagsString(action),
        @getRemoveAllFilteredTagsString(action),
        @getSuspendAutomaticResponsesString(action),
        @getReplaceAutomaticResponsesString(action)
      ], (str) -> str != "").join('<br>')
    else
      ""

  getRemoveAllTagsString: (action) ->
    if action.remove_all_tags
      "Quitar todos los tags"
    else
      ""

  getRemoveAllFilteredTagsString: (action) ->
    if action.remove_all_filtered_tags
      "Quitar todos los tags de la condición"
    else
      ""

  getSuspendAutomaticResponsesString: (action) ->
    if action.suspend_automatic_responses
      "Suspender las respuestas automáticas"
    else
      ""

  getReplaceAutomaticResponsesString: (action) ->
    if action.replace_automatic_responses
      "Reemplazar las respuestas automáticas"
    else
      ""
